import { createHttpClient } from "./http";

export class TermosUsoRepository {
	constructor() {
		this.axios = createHttpClient({ timeout: 30000 });
	}

	headers() {
		return { Authorization: `Bearer ${localStorage.getItem("access_token")}` };
	}

	// Os termos do Distribuidor são publicados no admin, separados dos do Campo.
	async getLatest() {
		try {
			const result = await this.axios.get("settings/termos/latest", {
				params: { sistema: "distribuidor" },
			});
			return result.data;
		} catch (error) {
			throw new Error("Erro ao carregar os Termos de Uso.");
		}
	}

	// O usuário vem do token: o backend sabe que é um usuário do Distribuidor.
	async checkAcceptance(termoId) {
		const result = await this.axios.get(`settings/termos/${termoId}/check-acceptance`, {
			headers: this.headers(),
		});
		return result.data;
	}

	async accept(termoId) {
		const result = await this.axios.post(`settings/termos/${termoId}/accept`, {}, {
			headers: this.headers(),
		});
		return result.data;
	}
}
